var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7293 5.18162L16.4793 0.0955547C16.1724 -0.0318203 15.8275 -0.0318828 15.5207 0.0955547L3.27069 5.18162C2.80413 5.37537 2.5 5.83087 2.5 6.33605V12.5189C2.5 21.0322 7.64556 28.6901 15.5276 31.9073C15.8304 32.0309 16.1696 32.0309 16.4724 31.9073C24.3543 28.6902 29.5 21.0322 29.5 12.5189V6.33605C29.5 5.83087 29.1959 5.37537 28.7293 5.18162ZM27 12.5189C27 19.7561 22.75 26.4184 16 29.3922C9.43038 26.4978 5 19.9522 5 12.5189V7.17055L16 2.60343L27 7.17055V12.5189ZM14.6184 16.7322L19.9911 11.3596C20.4792 10.8714 21.2707 10.8714 21.7589 11.3596C22.2471 11.8477 22.247 12.6392 21.7588 13.1273L15.5022 19.3839C15.014 19.8721 14.2226 19.8719 13.7345 19.3839L10.2411 15.8905C9.75294 15.4023 9.75294 14.6109 10.2411 14.1227C10.7293 13.6346 11.5208 13.6346 12.0089 14.1227L14.6184 16.7322Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.6008cacc0a71a7bc0cc00ae511b3da21.svg";
export { ForwardRef as ReactComponent };